import React from 'react'

import SheriSections from "./Component/S_Sections/Team"
import Team from "./Component/Team/Team"
import Utilities from "./Component/utilities/Utilities"
import Program from './Component/Program/Program'
import RoadMap from './Component/RoadMap/RoadMap'
import Ultra from './Component/Ultra/Ultra'

import "./Home.scss"

const Home = () => {
    return (
        <>
            <div className="home_container">
                <SheriSections />
                <Team />
                <Ultra/>
                <Utilities />
                <Program/>
                <RoadMap/>
            </div>
        </>
    )
}

export default Home
